export default "__VITE_ASSET__Bmvdnk26__"